import React from "react";
import { Chart } from "react-charts";
import useDemoConfig from "../../../hook/useDemoConfig";

export default function ChartGraph({ filters }) {
  const { data } = useDemoConfig({ filters });

  const primaryAxis = React.useMemo(
    () => ({
      getValue: (datum) => datum.primary,
    }),
    []
  );

  const secondaryAxes = React.useMemo(
    () => [
      {
        getValue: (datum) => datum.secondary,
        stacked: true,
      },
    ],
    []
  );

  const getSeriesStyle = React.useCallback((series) => {
    const colorPalette = {
      amount: "#4339F2",
    };

    return {
      fill: colorPalette[series.label],
    };
  }, []);

  if (!data[0]?.data?.length) {
    return <div>No data available</div>; // helpful fallback
  }

  return (
    <Chart
      options={{
        data,
        primaryAxis,
        secondaryAxes,
        getSeriesStyle,
      }}
    />
  );
}
